import js from './svg/js.svg';
import css from './svg/css3.svg';
import git from './svg/git.svg';
import html from './svg/html-5.svg';
import node from './svg/node.svg';
import react from './svg/react.svg';
import redux from './svg/redux.svg';
import sass from './svg/sass.svg';
import ts from './svg/ts.svg';
import webpack from './svg/webpack.svg';
import next from './svg/next.svg';
import vue from './svg/vue.svg';
import vite from './svg/vite.svg';

export const techs = [
  { name: 'JavaScript', image: js },
  { name: 'HTML', image: html },
  { name: 'CSS', image: css },
  { name: 'Sass', image: sass },
  { name: 'Git', image: git },
  { name: 'Webpack', image: webpack },
  { name: 'NodeJS', image: node },
  { name: 'React', image: react },
  { name: 'Redux', image: redux },
  { name: 'TypeScript', image: ts },
  { name: 'Next.js', image: next },
  { name: 'Vue', image: vue },
  { name: 'Vite', image: vite },
];
